import { useEffect, useRef, useMemo, memo } from 'react'
import { stripTgEmoji } from '../ui'

// ─────────────────────────────────────────────────────────
//  Telegram havolalarni aniqlash va embed qilish
//  https://t.me/channel/123  →  inline Telegram post widget
// ─────────────────────────────────────────────────────────

const TG_LINK_RE = /https?:\/\/t\.me\/([a-zA-Z0-9_]+)\/(\d+)/g

/** Matndan barcha Telegram post havolalarini ajratib beradi */
export function extractTelegramLinks(text) {
  if (!text) return []
  const matches = []
  let m
  const re = new RegExp(TG_LINK_RE.source, TG_LINK_RE.flags)
  while ((m = re.exec(text)) !== null) {
    matches.push({ url: m[0], channel: m[1], postId: m[2] })
  }
  return matches
}

/** Matnni Telegram havolalari bilan birga render qiladi (matn + linklar).
 *  Shablondan kelgan premium emoji tegi (<tg-emoji ...>) operatorga xom
 *  ko'rinmasin — fuqaro ko'radigan belgiga yig'iladi. */
export function RichText({ text: raw }) {
  const text = stripTgEmoji(raw)
  if (!text) return null
  const re = new RegExp(TG_LINK_RE.source, 'g')
  const parts = []
  let last = 0
  let m
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index))
    parts.push(
      <a key={m.index} href={m[0]} target="_blank" rel="noopener noreferrer"
         style={{ color: 'inherit', fontWeight: 600, textDecoration: 'underline' }}>
        {m[0]}
      </a>
    )
    last = m.index + m[0].length
  }
  if (last < text.length) parts.push(text.slice(last))
  return <>{parts}</>
}

/** Bitta Telegram postini iframe orqali ko'rsatadi (memo — qayta renderdan himoya) */
export const TelegramEmbed = memo(function TelegramEmbed({ channel, postId }) {
  const ref = useRef(null)
  const loadedRef = useRef(null)       // yuklangan post ID ni eslab qolish

  useEffect(() => {
    const key = `${channel}/${postId}`
    // Agar shu post allaqachon yuklangan bo'lsa — qayta yuklamaymiz
    if (loadedRef.current === key) return
    if (!ref.current) return

    ref.current.innerHTML = ''
    loadedRef.current = key
    
    const script = document.createElement('script')
    script.src = 'https://telegram.org/js/telegram-widget.js?22'
    script.setAttribute('data-telegram-post', key)
    script.setAttribute('data-width', '100%')
    script.setAttribute('data-userpic', 'false')
    script.async = true
    
    ref.current.appendChild(script)
  }, [channel, postId])

  return (
    <div className="tg-embed-wrap-outer" style={{ marginTop: 8, width: '100%', maxWidth: 360 }}>
      <div className="tg-embed-wrap" style={{ borderRadius: 12, overflow: 'hidden', border: '1px solid var(--border)' }}>
        <div ref={ref} style={{ minHeight: '80px' }} />
      </div>
    </div>
  )
})

/** Matndan barcha Telegram postlarini topib, har birini embed qiladi */
export const TelegramEmbeds = memo(function TelegramEmbeds({ text, isCit }) {
  const links = useMemo(() => extractTelegramLinks(text), [text])
  if (links.length === 0) return null
  return (
    <div className="tg-embeds" style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      width: '100%',
      maxWidth: 360,
      marginTop: 4,
      marginBottom: 6,
      alignSelf: isCit ? 'flex-start' : 'flex-end'
    }}>
      {links.map((l, i) => (
        <TelegramEmbed key={`${l.channel}-${l.postId}-${i}`} channel={l.channel} postId={l.postId} />
      ))}
    </div>
  )
})

